module.exports = function(logoName) {
  try {
    return require(`./logo-${logoName.toLowerCase()}.svg`)
  } catch (error) {
    throw new Error(`Missing logo asset for ${logoName}!`)
  }
}
